import React, { useState } from 'react';
import { X } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { TimeByLeadRow } from '../../utils/leadAnalytics';

interface Props {
  rows: TimeByLeadRow[];
  onClose: () => void;
}

type SortKey = 'total' | 'explicit' | 'implied';

const TimePerLeadPopover: React.FC<Props> = ({ rows, onClose }) => {
  const navigate = useNavigate();
  const [sortKey, setSortKey] = useState<SortKey>('total');
  const [expanded, setExpanded] = useState<string | null>(null);

  const sorted = [...rows].sort((a, b) => {
    if (sortKey === 'explicit') return b.explicitMinutes - a.explicitMinutes;
    if (sortKey === 'implied') return b.impliedMinutes - a.impliedMinutes;
    return b.totalMinutes - a.totalMinutes;
  });

  const fmt = (m: number) => (m >= 60 ? `${(m / 60).toFixed(1)}h` : `${m}m`);

  return (
    <div className="fin-modal-overlay" onClick={onClose}>
      <div
        className="fin-modal sa-time-modal"
        onClick={e => e.stopPropagation()}
        role="dialog"
        aria-modal="true"
        aria-label="Time per lead"
      >
        <div className="fin-modal-header">
          <h3>Time per lead</h3>
          <div className="sa-modal-header-tools">
            <div className="fin-forecast-toggle" role="group" aria-label="Sort time">
              {(['total', 'explicit', 'implied'] as SortKey[]).map(k => (
                <button
                  key={k}
                  type="button"
                  className={sortKey === k ? 'active' : ''}
                  onClick={() => setSortKey(k)}
                >
                  {k}
                </button>
              ))}
            </div>
            <button type="button" className="fin-modal-close" onClick={onClose} aria-label="Close">
              <X size={18} />
            </button>
          </div>
        </div>
        <div className="fin-modal-body">
          {sorted.length === 0 ? (
            <p className="sa-muted">No time entries recorded yet.</p>
          ) : (
            <ul className="sa-time-list">
              {sorted.map(row => (
                <li key={row.leadId}>
                  <button
                    type="button"
                    className="sa-time-row"
                    onClick={() => setExpanded(expanded === row.leadId ? null : row.leadId)}
                  >
                    <span className="sa-time-name">{row.leadName}</span>
                    <span>{fmt(row.totalMinutes)}</span>
                  </button>
                  {expanded === row.leadId && (
                    <div className="sa-time-detail">
                      {row.byUser.map(u => (
                        <div key={u.userId}>
                          {u.userName}: {fmt(u.minutes)} ({fmt(u.explicit)} explicit)
                        </div>
                      ))}
                      <button
                        type="button"
                        className="sa-text-link"
                        onClick={() => navigate(`/client/${row.leadId}`)}
                      >
                        Open lead
                      </button>
                    </div>
                  )}
                </li>
              ))}
            </ul>
          )}
        </div>
      </div>
    </div>
  );
};

export default TimePerLeadPopover;
